import React from 'react';
import BubbleText from './BubbleText';
import DetailsRow from './DetailsRow';
import moment from 'moment';

const utils = require('@airfi-disco/shared/utils');

const { sortByPosition } = utils;

declare const discoStaticPath: string;

const PLACEHOLDER_AIRPORTS = new Set(['XXX', 'ZZZ', 'UNK', '????', 'NULL', 'NONE']);

/** Hide telemetry placeholders; empty when there is no real airport. */
function formatAirportLabel(value?: string | null): string {
  const trimmed = value?.trim();
  if (!trimmed || PLACEHOLDER_AIRPORTS.has(trimmed.toUpperCase())) {
    return '';
  }
  return trimmed;
}

export interface AircraftBox {
  serial: string;
  health?: string;
  lastSeenTimestamp?: string | number | Date;
  position?: number;
}

interface AircraftRowProps {
  boxes?: AircraftBox[];
  tailNumber?: string;
  health?: string;
  arrivalTimestamp?: string | number | Date;
  departureTimestamp?: string | number | Date;
  destinationAirport?: string;
  originAirport?: string;
  status?: string;
}

function AircraftRow({
  boxes = [],
  tailNumber,
  health,
  arrivalTimestamp,
  departureTimestamp,
  destinationAirport,
  originAirport,
  status,
}: AircraftRowProps) {
  let arrivalTimeFrmowNow: string | undefined;
  if (arrivalTimestamp) {
    arrivalTimeFrmowNow = moment(arrivalTimestamp).fromNow();
  }
  let departureTimeFromNow: string | undefined;
  if (departureTimestamp) {
    departureTimeFromNow = moment(departureTimestamp).fromNow();
  }

  const boxRows = boxes
    .filter((b) => b)
    .sort(sortByPosition)
    .map((box) => {
      const lastUpdateFromNow = box.lastSeenTimestamp
        ? `Updated ${moment(box.lastSeenTimestamp).fromNow()}`
        : 'Never seen online';
      return (
        <div key={box.serial} className="fase-monitor__box-line">
          <BubbleText
            style={{ display: 'inline-block', width: 110 }}
            href={`#box/${box.serial}`}
            text={box.serial}
            bubbleType={box.health}
          />
          <span className="fase-monitor__box-updated">{lastUpdateFromNow}</span>
        </div>
      );
    });

  return (
    <article className="fase-monitor__aircraft-row">
      <div className="fase-monitor__aircraft-identity">
        <img src={`${discoStaticPath}/static/images/aircraft.png`} alt="" />
        <BubbleText
          href={`https://uk.flightaware.com/live/flight/${tailNumber}`}
          text={tailNumber}
          bubbleType={health}
        />
      </div>

      <div className="fase-monitor__aircraft-details">
        <div className="fase-monitor__aircraft-meta">
          <table>
            <tbody>
              <DetailsRow label="Status" value={status} />
              <DetailsRow label="Origin" value={formatAirportLabel(originAirport)} />
              <DetailsRow label="Destination" value={formatAirportLabel(destinationAirport)} />
              {status && ['Arrived / Gate Arrival', 'Arrived', 'Landed / Taxiing'].indexOf(status) > -1 ? (
                <DetailsRow label="Arrival time" value={arrivalTimeFrmowNow} />
              ) : (
                <DetailsRow label="Departure time" value={departureTimeFromNow} />
              )}
            </tbody>
          </table>
        </div>

        <div>
          <span className="fase-monitor__aircraft-boxes-label">Boxes</span>
          {boxRows}
        </div>
      </div>
    </article>
  );
}

export default AircraftRow;
